import utils from '@eitje/utils'
import _ from 'lodash'
import {getModel} from '../record_building/model_metadata'
import {sortRecords} from './sort_records'

export function assertUniqueRecords(items, {kind = 'unknown', iden = 'id'} = {}) {
	if (process.env.NODE_ENV === 'production') return items
	if (!Array.isArray(items) || items.length < 2) return items

	if (_.uniqBy(items, iden).length === items.length) return items

	throw new Error(`[records] Duplicate ${kind} records detected`)
}

export const mapScopeIds = ({combined, old, newItem}) => {
	if (old.updated_at != newItem.updated_at) return combined

	const scopeIds = mergeScopeIds(old.scopeIds, newItem.scopeIds)
	return {...combined, scopeIds}
}

export const indexRecords = ({oldItems = [], newItems = [], destroyedIds, removedFromScopeIds, scopeId, force = false, kind} = {}) => {
	assertUniqueRecords(newItems, {kind})
	if (force) return sortIndexedRecords(newItems, kind)

	const filteredOldItems = filterOldItems({oldItems, destroyedIds, removedFromScopeIds, scopeId})
	const indexItems = utils.findAndReplace({
		oldItems: filteredOldItems,
		newItems,
		merge: mapScopeIds,
	})

	assertUniqueRecords(indexItems, {kind})
	return sortIndexedRecords(indexItems, kind)
}

const sortIndexedRecords = (items, kind) => {
	const {sort} = getModel(kind)
	if (!sort) return items
	return sortRecords(items, sort)
}

function filterOldItems({oldItems, destroyedIds, removedFromScopeIds, scopeId}) {
	let filteredOldItems = oldItems

	if (_.isArray(destroyedIds) && destroyedIds.length > 0) {
		filteredOldItems = filteredOldItems.filter(i => !destroyedIds.includes(i.id))
	}

	if (_.isArray(removedFromScopeIds) && removedFromScopeIds.length > 0) {
		filteredOldItems = filteredOldItems
			.map(i => {
				if (!removedFromScopeIds.includes(i.id)) return i
				const scopeIds = (i.scopeIds || []).filter(id => id !== scopeId)
				return scopeIds.length === 0 ? null : {...i, scopeIds}
			})
			.filter(Boolean)
	}

	return filteredOldItems
}

const mergeScopeIds = (oldScopeIds = [], newScopeIds = []) => {
	if (oldScopeIds.length === 0) return newScopeIds
	if (newScopeIds.length === 0) return oldScopeIds

	const scopeIds = [...oldScopeIds]

	newScopeIds.forEach(scopeId => {
		if (!scopeIds.includes(scopeId)) scopeIds.push(scopeId)
	})

	return scopeIds
}
